import React from 'react';
import './MainContentArea.css';

const MainContentArea = ({ isMenuOpen, disableTransition = false, children }) => {
  return (
    <main className={`main-content-area ${isMenuOpen ? 'menu-open' : ''} ${disableTransition ? 'no-anim' : ''}`}>
      {children}
    </main>
  );
};

export default MainContentArea;
